import { PlusOutlined } from "@ant-design/icons";
import { Button, Alert } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import UserEdit from "@/features/Users/UserEdit";
import { useSidePanel } from "@/modules/side-panel";
import "./UserOrganizationNoRoleAlert.less";

const UserOrganizationNoRoleAlert = ({ user }) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const handleClick = () => {
    openSidePanel({
      title: user.name,
      component: <UserEdit userId={user.id} />,
    });
  };

  return (
    <Alert
      type="error"
      showIcon
      title={t(`user:organizationRole.noRole.label`, {
        organization: user.organization?.name,
      })}
      description={t(`user:organizationRole.noRole.description`)}
      action={
        <Button icon={<PlusOutlined />} onClick={handleClick}>
          {t("global:add")} {t("user:role")}
        </Button>
      }
      className="user-organization-no-role-alert"
    />
  );
};

UserOrganizationNoRoleAlert.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserOrganizationNoRoleAlert;
